import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';
import { dispatch } from '../index';
import { openSnackbar } from './snackbar';
import { ARYABHATTA_API_DOMAIN_V1 } from 'config';
import { DEFAULT_ERROR_MESSAGE } from 'store/constant';
import { ADD_CHILD_BOOKING } from 'views/pages/booking-details/linkedBookings/constants';

const initialState = {
    linkedBookingData: {
        childBookings: [],
        parentBooking: {},
        currency: {},
        bookingDetails: {},
        bookingCode: ''
    },
    isLoadingLinkedBooking: false
};
const slice = createSlice({
    initialState,
    name: 'linkedBooking',
    reducers: {
        setIsLoadingLinkedBooking(state, action) {
            state.isLoadingLinkedBooking = action.payload;
        },
        setLinkedBookingData(state, action) {
            const { childBookings = [], parentBooking = {}, currency = {}, bookingDetails = {}, bookingCode = '' } = action.payload;
            state.linkedBookingData = {
                childBookings,
                parentBooking,
                currency,
                bookingDetails,
                bookingCode
            };
        },
        resetLinkedBooking() {
            return initialState;
        }
    }
});
export default slice.reducer;
export const { setIsLoadingLinkedBooking, setLinkedBookingData, resetLinkedBooking } = slice.actions;

export const addparentBooking = (payload) => async () => {
    const url = `${ARYABHATTA_API_DOMAIN_V1}acm/members/`;
    try {
        const response = await axios.patch(url, payload, {
            headers: {
                source: 'aiservice'
            }
        });
    } catch (errorMessage) {
        dispatch(
            openSnackbar({
                open: true,
                message: errorMessage || DEFAULT_ERROR_MESSAGE,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false
            })
        );
    }
};
export const addChidBooking = (payload) => async () => {
    const url = `${ARYABHATTA_API_DOMAIN_V1}acm/members/`;
    try {
        const response = await axios.patch(url, payload, {
            headers: {
                source: 'aiservice'
            }
        });
    } catch (errorMessage) {
        dispatch(
            openSnackbar({
                open: true,
                message: errorMessage || DEFAULT_ERROR_MESSAGE,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false
            })
        );
    }
};
export function patchBookingDataLinkedBooking(
    bookingCode = '',
    updatedData,
    snackbarText = '',
    formik,
    setShowForceLinkingModal,
    getBookingCodeData,
    showFormError = true,
    setShowAddBookingForm = () => {},
    type
) {
    const code = updatedData?.child_booking?.code;
    const matchError = `Booking code ${code} is linked to another booking`;
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/?booking_code=${bookingCode}`;
        try {
            dispatch(setIsLoadingLinkedBooking(true));
            const response = await axios.patch(url, updatedData, {
                headers: {
                    source: 'mweb'
                }
            });
            if (showFormError) {
                formik.resetForm();
                if (type === ADD_CHILD_BOOKING) {
                    setShowAddBookingForm((prev) => ({ ...prev, childBooking: false }));
                } else {
                    setShowAddBookingForm((prev) => ({ ...prev, parentBooking: false }));
                }
            }
            await getBookingCodeData();
            dispatch(
                openSnackbar({
                    open: true,
                    message: snackbarText || 'Booking updated successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
        } catch (error) {
            const { response: errorResponse } = error;
            const { data = {} } = errorResponse || {};
            const { error: errorOccured = {} } = data || {};

            if (errorOccured && typeof errorOccured === 'object' && Object?.keys(errorOccured)?.length > 0) {
                if (errorOccured?.errorCode === 400) {
                    if (errorOccured?.errorMessage === matchError) {
                        setShowForceLinkingModal((prev) => ({ ...prev, open: true }));
                    } else if (showFormError) {
                        formik.setFieldError('code', errorOccured?.errorMessage || 'Booking code is invalid');
                    } else {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: errorOccured?.errorMessage || DEFAULT_ERROR_MESSAGE,
                                variant: 'alert',
                                alert: {
                                    color: 'error'
                                },
                                close: false
                            })
                        );
                    }
                }
            }
        } finally {
            dispatch(setIsLoadingLinkedBooking(false));
        }
    };
}
